import { render, staticRenderFns } from "./PetHealthTypePreventionForm.vue?vue&type=template&id=e6ca085e&scoped=true&"
import script from "./PetHealthTypePreventionForm.vue?vue&type=script&lang=js&"
export * from "./PetHealthTypePreventionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ca085e",
  null
  
)

export default component.exports